import { useLocations } from "../../utils/api.hook";
import { LocationCheckGroupComponent } from "./location-check-group.component";

export function LocationCheckGroupContainer() {
  const { data: { locations } = {} } = useLocations({});

  return <LocationCheckGroupComponent locations={locations || []} />;
}
